mutation UserSignatureUploadDocument ($userProfileId: UUID){
  userSignatureUploadDocument ( userProfileId: $userProfileId){
      document { 
      _documentFileId
    }
    uploadLink 
  }
}
 